export default __webpack_public_path__ + "static/onelogin-74d6f94dd4fd6f53cdb58d8fa994e160.svg";